//expects a UNIX timestamp or Date object

export function toDate(dateish: string | number | Date) {
  if (typeof dateish === "string") {
    return new Date(dateish);
  } else if (typeof dateish === "number") {
    return new Date(dateish * 1000);
  }

  return new Date(dateish);
}

export function niceDate(dateish: string | number | Date) {
  return toDate(dateish).toLocaleDateString("en-US", {});
}

export function niceYear(dateish: string | number | Date) {
  return toDate(dateish).toLocaleDateString("en-US", { year: "numeric" });
}
